import { theme, styled, utils } from 'ui/theme';

export const Container = styled.div`
  ${utils.container};

  /* MARGIN-BOTTOM */
  &[data-margin-bottom='sp-0'] {
    margin-bottom: ${theme.space[0]};
  }

  &[data-margin-bottom='sp-2'] {
    margin-bottom: ${theme.space[2]};
  }

  &[data-margin-bottom='sp-4'] {
    margin-bottom: ${theme.space[4]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[2]};
    `}
  }

  &[data-margin-bottom='sp-6'] {
    margin-bottom: ${theme.space[6]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[3]};
    `}
  }

  &[data-margin-bottom='sp-8'] {
    margin-bottom: ${theme.space[8]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[4]};
    `}
  }

  &[data-margin-bottom='sp-10'] {
    margin-bottom: ${theme.space[10]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[5]};
    `}
  }

  &[data-margin-bottom='sp-12'] {
    margin-bottom: ${theme.space[12]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[6]};
    `}
  }

  &[data-margin-bottom='sp-14'] {
    margin-bottom: ${theme.space[14]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[7]};
    `}
  }

  &[data-margin-bottom='sp-16'] {
    margin-bottom: ${theme.space[16]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[8]};
    `}
  }

  &[data-margin-bottom='sp-18'] {
    margin-bottom: ${theme.space[18]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[9]};
    `}
  }

  &[data-margin-bottom='sp-20'] {
    margin-bottom: ${theme.space[20]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[10]};
    `}
  }

  &[data-margin-bottom='sp-22'] {
    margin-bottom: ${theme.space[22]};

    ${utils.media.max('l')`
      margin-bottom: ${theme.space[11]};
    `}
  }

  /* MARGIN-TOP */
  &[data-margin-top='sp-0'] {
    margin-top: ${theme.space[0]};
  }

  &[data-margin-top='sp-2'] {
    margin-top: ${theme.space[2]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[1]};
    `}
  }

  &[data-margin-top='sp-4'] {
    margin-top: ${theme.space[4]};
  }

  &[data-margin-top='sp-6'] {
    margin-top: ${theme.space[6]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[3]};
    `}
  }

  &[data-margin-top='sp-8'] {
    margin-top: ${theme.space[8]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[4]};
    `}
  }

  &[data-margin-top='sp-10'] {
    margin-top: ${theme.space[10]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[5]};
    `}
  }

  &[data-margin-top='sp-12'] {
    margin-top: ${theme.space[12]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[6]};
    `}
  }

  &[data-margin-top='sp-14'] {
    margin-top: ${theme.space[14]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[7]};
    `}
  }

  &[data-margin-top='sp-16'] {
    margin-top: ${theme.space[16]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[8]};
    `}
  }

  &[data-margin-top='sp-18'] {
    margin-top: ${theme.space[18]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[9]};
    `}
  }

  &[data-margin-top='sp-20'] {
    margin-top: ${theme.space[20]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[10]};
    `}
  }

  &[data-margin-top='sp-22'] {
    margin-top: ${theme.space[22]};

    ${utils.media.max('l')`
      margin-top: ${theme.space[11]};
    `}
  }

  &[data-horizontal-align='center'] {
    text-align: center;
  }
  &[data-horizontal-align='left'] {
    text-align: left;
  }
  &[data-horizontal-align='right'] {
    text-align: right;
  }

  /* SIZE */
  &[data-size='full'] {
    max-width: 100%;
  }

  &[data-size='1/2'] {
    max-width: calc(${utils.containerMaxWidth}px / 2);
  }

  &[data-size='1/3'] {
    max-width: calc(${utils.containerMaxWidth}px / 3);
  }

  &[data-size='2/3'] {
    max-width: calc(2 * ${utils.containerMaxWidth}px / 3);
  }

  &[data-fluid='true'] {
    ${utils.containerFluid};
  }

  &[data-horizontal-align='center'] {
    text-align: center;
  }

  &[data-horizontal-align='left'] {
    text-align: left;
  }

  &[data-horizontal-align='right'] {
    text-align: right;
  }
`;
